import { render } from "./BannerFirstPage.vue?vue&type=template&id=fa67b164"
import script from "./BannerFirstPage.vue?vue&type=script&lang=js"
export * from "./BannerFirstPage.vue?vue&type=script&lang=js"

import "./BannerFirstPage.vue?vue&type=style&index=0&id=fa67b164&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__